/* template */
<template minapp="mpx" xlang="wxml"><div class="coupon-container"><span v-if="(couponInfo.name)">{{ couponInfo.name }}</span></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m17eb0cf7"}'>
  .coupon-container
    border-radius 2px
    border 0.5px solid #FF4343
    padding 4px 5px
    margin-right 8px
    font-family PingFang SC
    font-size 10px
    font-weight 500
    line-height 10px
    color #FF4343
    flex-shrink 0
    position relative
    // 替换成 drop-shadow
    -webkit-mask radial-gradient(circle at 3px, transparent 3px, #000 0) -3px
    mask radial-gradient(circle at 3px , transparent 3px, #000 0) -3px
    &:last-child
      margin-right 0
    &::before, &::after
      content ''
      position absolute
      top 5.2px
      width 8.2px
      height 6.5px
      border-radius 50%
      border 0.5px solid #FF4343
    &::before
      left -5.2px
    &::after
      right -5.2px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m17eb0cf7"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./coupon.mpx.js?isComponent&outputPath=components%2Fcoupon17eb0cf7%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./coupon.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcoupon17eb0cf7%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m17eb0cf7"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/coupon17eb0cf7/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
